import {
  DispatchRequestTrackingResult,
  DispatchTrackingResult
} from "@ots-frontend/ots-data";

type TrackingResult = DispatchTrackingResult | DispatchRequestTrackingResult;
type StatusLike = string | { code?: string } | undefined;

const FAST_REFRESH_MS = 15000;
const NORMAL_REFRESH_MS = 30000;
const SLOW_REFRESH_MS = 60000;
const DISABLED_REFRESH_MS = 0;

const TERMINAL_STATUSES = new Set([
  "CANCELED",
  "CANCELLED",
  "CLOSED",
  "COMPLETE",
  "COMPLETED",
  "PENDING_CANCEL",
  "REASSIGNED",
  "REJECTED",
  "UNRESOLVED"
]);

const ACTIVE_STATUSES = new Set([
  "PICKED_UP",
  "STARTED"
]);

const PENDING_STATUSES = new Set([
  "ACCEPTED",
  "PENDING"
]);

const getStatusCode = (status: StatusLike): string | undefined => {
  if (typeof status === "string") {
    return status.toUpperCase();
  }

  return status?.code?.toUpperCase();
}

export const isDispatchTrackingClosedStatus = (status: StatusLike): boolean => {
  const statusCode = getStatusCode(status);
  return Boolean(statusCode && TERMINAL_STATUSES.has(statusCode));
}

export const getDispatchTrackingPollingInterval = (
  entityStatus: StatusLike,
  tracking?: TrackingResult
): number => {
  const status = getStatusCode(tracking?.status) ?? getStatusCode(entityStatus);

  if (status && isDispatchTrackingClosedStatus(status)) {
    return DISABLED_REFRESH_MS;
  }

  if (tracking?.confidence?.trackable === false && !tracking?.performer) {
    return SLOW_REFRESH_MS;
  }

  if (tracking?.performer?.locationContext?.location) {
    if (tracking.route?.etaDttm || status && ACTIVE_STATUSES.has(status)) {
      return FAST_REFRESH_MS;
    }

    if (tracking.confidence?.level === "HIGH" || tracking.confidence?.level === "MEDIUM") {
      return NORMAL_REFRESH_MS;
    }
  }

  if (status && ACTIVE_STATUSES.has(status)) {
    return FAST_REFRESH_MS;
  }

  if (status && PENDING_STATUSES.has(status)) {
    return SLOW_REFRESH_MS;
  }

  return NORMAL_REFRESH_MS;
}

export const getDispatchTrackingPollingLabel = (interval: number): string | undefined => {
  if (interval <= 0) {
    return undefined;
  }

  return `${Math.round(interval / 1000)}s`;
}
